import React from 'react';
import { EmailShareButton, FacebookShareButton, LinkedinShareButton, TwitterShareButton, WhatsappShareButton, PinterestShareButton, RedditShareButton, TelegramShareButton } from 'react-share';
import './style.scss';
var ShareButton = function ShareButton(_ref) {
  var type = _ref.type,
    pageTitle = _ref.pageTitle,
    url = _ref.url,
    _onClick = _ref.onClick,
    withLabels = _ref.withLabels;
  var types = {
    mail: EmailShareButton,
    facebook: FacebookShareButton,
    linkedin: LinkedinShareButton,
    twitter: TwitterShareButton,
    whatsapp: WhatsappShareButton,
    pinterest: PinterestShareButton,
    reddit: RedditShareButton,
    telegram: TelegramShareButton
  };
  var Component = types[type];
  return /*#__PURE__*/React.createElement("div", {
    className: "Share__item-wrapper",
    onClick: function onClick() {
      return _onClick(type);
    }
  }, /*#__PURE__*/React.createElement(Component, {
    body: pageTitle,
    title: pageTitle,
    url: url
  }, /*#__PURE__*/React.createElement("div", {
    className: "Share__item ".concat(type)
  }, /*#__PURE__*/React.createElement("div", {
    className: "icon icon-".concat(type)
  }), withLabels && /*#__PURE__*/React.createElement("span", {
    className: "Share__item__label"
  }, type.charAt(0).toUpperCase() + type.slice(1)))));
};
var Share = function Share(_ref2) {
  var title = _ref2.title,
    pageTitle = _ref2.pageTitle,
    url = _ref2.url,
    items = _ref2.items,
    onClick = _ref2.onClick,
    customItems = _ref2.customItems,
    withLabels = _ref2.withLabels;
  var windowUrl = url || window.location.href;
  var buttons = items.map(function (item) {
    if (customItems && customItems[item]) {
      return customItems[item];
    } else {
      return /*#__PURE__*/React.createElement(ShareButton, {
        type: item,
        key: "".concat(item, ":").concat(url),
        pageTitle: pageTitle,
        onClick: onClick,
        url: windowUrl,
        withLabels: withLabels
      });
    }
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "Share"
  }, /*#__PURE__*/React.createElement("div", {
    className: "Share__wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "Share__title",
    tabIndex: "0"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "Share__buttons"
  }, buttons)));
};
Share.defaultProps = {
  title: 'Share this page:',
  pageTitle: '',
  url: null,
  items: ['mail', 'facebook', 'linkedin', 'twitter', 'whatsapp'],
  onClick: function onClick() {},
  withLabels: false,
  customItems: {}
};
export default Share;